<template>
  <div class="main-thing">
    <b-row>
      <admin-info />
    </b-row>
    <!--  <b-row>-->
    <!--    <tasks/>-->
    <!--  </b-row>-->
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import AdminInfo from "@/components/inputgroups/AdminInfo";
// import Tasks from "@/components/Tasks";

const axios = require("axios");
export default {
  name: "Profile",
  components: {
    AdminInfo,
    // Tasks
  },
  data: function () {
    return {
      admin: {},
    };
  },
  computed: {
    ...mapState(["user"]),
  },
  async mounted() {
    this.admin = this.user;
    console.log(this.admin, this.user);
    await this.getMe();
  },
  methods: {
    ...mapActions(["setUser", "logOutUser"]),
    async getMe() {
      const config = {
        headers: {
          Authorization: `Bearer ${this.$cookie.get("access_token")}`,
        },
      };
      await axios
        .get(
          `${process.env.VUE_APP_API}/admin/info/${this.admin[0].id}`,
          config,
        )
        .then((response) => {
          console.log(response.data);
        })
        .catch((err) => {
          if (err.response.status === 401) {
            this.logOutUser();
          }
        });
    },
  },
};
</script>

<style scoped>
.main-thing {
  display: block;
}
.info {
  width: 100%;
  display: block;
}
.task-creator {
  margin: auto;
  display: flex;
}
.block-header {
  display: flex;
  margin: 20px auto 20px auto;
  font-weight: bold;
}
.tasks-info {
  display: flex;
  margin: auto;
  width: 90%;
  flex-wrap: wrap;
  flex-direction: row;
}
.tasks-categories {
  margin: 0.5rem 15rem 2rem 15rem;
}
</style>
